export const Easings = {
  CUSTOM: 'cubic-bezier(0.175, 0.35, 0.32, 0.8)',
}
